import { render } from "./invoice-modal.vue?vue&type=template&id=21ee70d4&scoped=true"
import script from "./invoice-modal.vue?vue&type=script&lang=js"
export * from "./invoice-modal.vue?vue&type=script&lang=js"

import "./invoice-modal.vue?vue&type=style&index=0&id=21ee70d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ee70d4"]])

export default __exports__